module.exports = __webpack_public_path__ + "img/Czechia_GP3_Obrazek2-1.0e2e84e3.jpg";